import { IAutomationObject } from '../../types'

export interface IPID extends IAutomationObject {
    x: number;
    xDimension: string;
    w: number;
    y: number;
    yDimension: string;
    p: number;
    pDimension: string;
    i: number;
    iDimension: string;
    d: number;
    dDimension: string;
    
    yMin: number;
    yMax: number;

    iMin: number;
    iMax: number;

    onValueChanged: any;

}


export const schema = 'AutomationApps.Functions.Controllers.PID';



